import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { projectService } from '@/services/http/projectService'

type UseGetProjectProps = {
  projectId: string
  enabled?: boolean
}

export const useGetProject = ({
  projectId,
  enabled = true,
}: UseGetProjectProps) => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['portfolioProject', projectId],
    queryFn: () => projectService.project.getProject({ projectId }),
    retry: false,
    enabled,
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar o projeto',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    return {
      project: data,
      isLoading,
      refetchProject: refetch,
    }
  }

  return {
    project: null,
    isLoading,
    refetchProject: refetch,
  }
}
